window.Vue = require( 'vue' );

import './imports/fontAwesome.js';

import VeeValidate from 'vee-validate';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.component('Consent', require( './components/auth/consent.vue' ).default );

Vue.component('MainLogin', require( './components/auth/login.vue' ).default );

Vue.component('PassReset', require( './components/auth/ForgotPass.vue' ).default );

Vue.component('PassChallenge', require( './components/auth/PassChallenge.vue' ).default );

Vue.component('Notification', require( './components/auth/Notification.vue' ).default );

Vue.component('AccountKeyword', require( './components/auth/newAccount/keyword.vue' ).default );
Vue.component('TermsAgreement', require( './components/auth/newAccount/termsAgreement.vue' ).default );
Vue.component('ApplicationForm', require( './components/auth/newAccount/ApplicationForm.vue' ).default );

Vue.component('DatePicker', require( './components/DatePicker.vue' ).default );

// Todo use in registration sprint
// Vue.component('regConfirmEmail', require( './components/auth/registration/confirmEmail.vue' ).default );
// Vue.component('regForm', require( './components/auth/registration/regForm.vue' ).default );

Vue.component('SapphireHeader', require( './components/SapphireHeader.vue' ).default );

Vue.use(VeeValidate);

new Vue( {
    el : '#app',

    components : { },

    mounted : function() {

        if ( Vue.config.devtools && console.log ) {
            console.log( 'ColdBox, Vue and Vueify all set to go!' );
            console.log( "Vue Version " + Vue.version );
		}
    }
} );
